/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { Me } from './model/me';

export const apiFrontendUserPersonSummaryRetrieve = (signal?: AbortSignal) => {
  return HTTP<Me>({ url: `/api/v7/frontend/user-person-summary/`, method: 'GET', signal });
};

export const getApiFrontendUserPersonSummaryRetrieveQueryKey = () => {
  return [`/api/v7/frontend/user-person-summary/`] as const;
};

export const getApiFrontendUserPersonSummaryRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiFrontendUserPersonSummaryRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendUserPersonSummaryRetrieve>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getApiFrontendUserPersonSummaryRetrieveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendUserPersonSummaryRetrieve>>
  > = ({ signal }) => apiFrontendUserPersonSummaryRetrieve(signal);

  return {
    queryKey,
    queryFn,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendUserPersonSummaryRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiFrontendUserPersonSummaryRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendUserPersonSummaryRetrieve>>
>;
export type ApiFrontendUserPersonSummaryRetrieveQueryError = ErrorType<unknown>;

export function useApiFrontendUserPersonSummaryRetrieve<
  TData = Awaited<ReturnType<typeof apiFrontendUserPersonSummaryRetrieve>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendUserPersonSummaryRetrieve>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiFrontendUserPersonSummaryRetrieveQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
